/** @format */

export const API = process.env.REACT_APP_API_URL;
export const API_CHAT = 'wss://rest.tele724.online';
// export const API = 'http://94.100.50.222:8008';
// export const API_CHAT = 'ws://94.100.50.222:8008';
export const site = 'stock.teletava.com';
